import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mx-auto" };
const _hoisted_2 = {
    class: "pagination",
    "aria-label": "..."
};
const _hoisted_3 = { class: "pagination justify-content-center" };
const _hoisted_4 = { class: "page-item current-page" };
const _hoisted_5 = { class: "page-index" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
                _createElementVNode("li", {
                    class: _normalizeClass(["page-item", { disabled: $setup.currentPage === 1 || $props.isLoading }])
                }, [
                    _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _withModifiers($setup.decreasePage, ["prevent"])
                    }, _toDisplayString(_ctx.$t('JTADM_LAYOUT_PREVIOUS')), 1)
                ], 2),
                _createElementVNode("li", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString($setup.currentPage), 1),
                    _createVNode($setup["Multiselect"], {
                        modelValue: $setup.currentPage,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.currentPage) = $event)),
                        "allow-empty": false,
                        options: $setup.pages,
                        "show-labels": false,
                        searchable: false,
                        onSelect: $setup.goToPage
                    }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("li", {
                    class: _normalizeClass(["page-item", { disabled: !$setup.hasNext || $props.isLoading }])
                }, [
                    _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _withModifiers($setup.increasePage, ["prevent"])
                    }, _toDisplayString(_ctx.$t('JTADM_LAYOUT_NEXT')), 1)
                ], 2)
            ])
        ])
    ]));
}
